import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "scaffold-paginator",
  templateUrl: "./paginator.component.html",
  styleUrls: ["./paginator.component.scss"],
})
export class PaginatorComponent implements OnInit {

  _count = 1;
  _perPage = 15;
  @Input("perPage")
  set perPage(count: number) {
    this._perPage = count;
    this.calcPageCount();
  }
  get perPage(): number {
    return this._perPage;
  }
  @Input() activePage = 1;
  @Output() activePageChange: EventEmitter<number> = new EventEmitter();
  pageCount = 1;
  @Input("itemCount")
  set itemCount(count: number) {
    this._count = count;
    this.calcPageCount();
  }
  get itemCount(): number {
    return this._count;
  }

  calcPageCount() {
    console.log(
      this.itemCount,
      this.perPage,
      Math.ceil(this.itemCount / this.perPage)
    );
    if (!this.itemCount) {
      this.pageCount = this.activePage;
    } else {
      this.pageCount = Math.ceil(this.itemCount / this.perPage);
    }
  }

  constructor() {
    console.log(this.pageCount);
  }
  setPage(page) {
    console.log(page, this.itemCount);
    if (this.itemCount) {
      this.activePage = page;
      console.log(page);
      this.activePageChange.emit(page);
    }
  }
  ngOnInit() {}
}
